export const EXCHANGE_PROVIDER_PROCESS_STEP = {
  EXCHANGE_CONFIRM: 'exchangeConfirm',
  WRONG_ACCOUNT_NUMBER: 'wrongAccountNumber',
  CONNECTED_ACCOUNT: 'connectedAccount',
  CHANGED_ACCOUNT: 'changedAccount'
}

export const REWARD_POINTS_PROCESS_STEP = {
  CODE_EXPIRED: 'codeExpired',
  WRONG_REWARD_CODE: 'wrongRewardCode',
  TOO_MANY_TRIES: 'tooManyTries',
  REWARD_FROM_CODE_FAILED: 'rewardFromCodeFailed',
  POINTS_RECEIVED: 'pointsReceived',
  CODE_ALREADY_USED: 'codeAlreadyUsed'
}

export const REDEEM_POINTS_PROCESS_STEP = {
  POINTS_REDEEMED: 'pointsRedeemed',
  EXCHANGE_FAILED: 'exchangeFailed',
  REDEEM_POINTS: 'redeemPoints',
  NO_ENOUGH_POINTS: 'noEnoughPoints',
  UNSUPPORTED_COUNTRY: 'unsupportedCountry',
  REDEEM_EXTERNAL_REWARDS: 'redeemExternalRewards',
  EXTERNAL_REWARDS_REDEEMED: 'externalRewardsRedeemed'
}

export const SIGNUP_PROCESS_STEP = {
  SIGNUP_SUCCESS: 'signUpSuccess',
  RESEND_VERIFICATION_SUCCESS: 'resendVerificationSuccess',
  RESEND_VERIFICATION_FAILED: 'resendVerificationFailed',
  SIGNUP_VERIFIED: 'signUpVerified',
  CONFIRM_VERIFICATION_FAILED: 'confirmVerificationFailed'
}

export const QR_CODE_PROCESS_STEP = {
  SCAN_CODE: 'scanCode',
  CAMERA_BLOCKED: 'cameraBlocked'
}

export const REWARD_NFT_PROCESS_STEP = {
  NFT_RECEIVED: 'nftReceived'
}

export const DEFAULT_CONTAINER_STATE = {
  NONE: '',
  SOMETHING_WENT_WRONG: 'somethingWentWrong',
  FEATURE_LOCKED: 'featureLocked',
  PURCHASE_STATUS: 'purchaseStatus',
  PURCHASE_STATUS_CONFIRMATION: 'purchaseStatusConfirmation',
  PURCHASE_STATUS_SUCCESS: 'purchaseStatusSuccess',
  WALLET_CONNECT: 'walletConnect'
}

export const ACCOUNT_INIT_PROCESS_STEP = {
  CREATE_ACCOUNT_FAILED: 'createAccountFailed'
}

export const BUY_POINTS_PROCESS_STEP = {
  PURCHASED_POINTS_CONFIRMATION: 'purchasedPointsConfirmation'
}

export const TRANSACTIONS_PROCESS_STEP = {
  FUTURE_POINTS_INFO: 'futurePointsInfo'
}

export const STAKING_PROCESS_STEP = {
  STAKE: 'stake',
  UN_STAKE: 'unStake',
  REWARD_CLAIM: 'rewardClaim',
  SYMBOL_REWARD_CLAIM: 'symbolRewardClaim',
  SUCCESS: 'success',
  CANNOT_CHANGE_WALLET: 'cannotChangeWallet',
  CONNECT_WALLET: 'connectWallet'
}

export const REWARD_BOX_PROCESS_STEP = {
  ACHIEVED_MILESTONE: 'achievedMilestone'
}

export const GAMES_PROCESS_STEP = {
  ACHIEVED_MILESTONE: 'confirmation'
}
